import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { Icon } from '../../ui';
import { Text } from '../../ui/Text';
import { StyledLink } from './TextLink.style';
export const TextLink = ({ href, children, className, target, size, rel, onClick, underline, showIcon, iconName, }) => {
    const theme = useTheme();
    return (_jsxs(StyledLink, { href: href, className: className, target: target, rel: rel, onClick: onClick, underline: underline, children: [_jsx(Text, { size: size, children: children }), showIcon && iconName && (_jsx(Icon, { name: iconName, color: theme.Color.Neutrals.Dark }))] }));
};
//# sourceMappingURL=TextLink.js.map